import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'react-bootstrap';
import { SectionBoxStyled } from './SectionBoxStyled';

const SectionBox = (props) => (
    <SectionBoxStyled className={props?.customOuterClass} isGlobalCarousel={props?.isGlobalCarousel} bgColor={props?.bgColor}>
      <Container className={props?.customClass} >
        <div className="titleBar">
          {props?.title && (
            <h2 className="title">
              {props?.title} <span className="subText">{props?.subText}</span>
            </h2>
          )}
          {props?.rightTop && <div className="rightTop">
            {props?.rightTop}
          </div>}
        </div>
        {props?.children}
      </Container>
    </SectionBoxStyled>
  );

SectionBox.propTypes = {
  children: PropTypes.element,
  title: PropTypes.string,
  subText: PropTypes.string,
  customClass: PropTypes.string,
  rightTop: PropTypes.any,
  customOuterClass: PropTypes.string,
  isGlobalCarousel: PropTypes.bool,
  bgColor: PropTypes.string,
};

SectionBox.defaultProps = {
  title: '',
  subText: '',
  customClass: '',
  customOuterClass: '',
  isGlobalCarousel: false,
  bgColor: '',
};

export default SectionBox;
